import { NeededFromEq } from '../OnBoardingModal.utils';
import { EquipmentTypeKeepNulls, GlobalEquipment } from '../types';

export function mergeFields(
  old: NeededFromEq['fields'],
  newFields:
    | EquipmentTypeKeepNulls['customFields']
    | GlobalEquipment['customFields'],
) {
  const updatedFields = Object.values(newFields)
    .filter(
      (value): value is EquipmentTypeKeepNulls['customFields'][string] =>
        value.content !== undefined,
    )
    .map(({ content, id }) => {
      return { content, customFieldId: id };
    });
  const untouchedFields = old.filter(field => !newFields[field.customFieldId]);
  return [...updatedFields, ...untouchedFields];
}
